<template>
    <div class="home-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li><span>{{$t('Conversation')}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/Conversation-bg.jpg) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp fw7">かいわ</div>
                  <div class="jp">{{$t('Conversation')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
		<div class="">
      <div class="content crfff por">
        <div class="title mt20 ac">{{$t('Choose_Lesson')}}</div>
        <div class="list-content">
          <div class="home-block5" v-for="(item,index) in list" @click="getToDetail(item)">
            <img :src="item.cover_image" loading="lazy">
            <div class="conversation-list">
              <div class="cvation-num disflex">
                <span class="cvation-num-l fw7">{{item.num}}</span>
                <div class="cvation-num-r">{{item.topic_en}}</div>
              </div>
              <div class="mt10">{{item.title_jp}}</div>
              <div class="mt10">{{item.title_en}}</div>
            </div>
          </div>
        </div>
      </div>
		</div>

      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Grammar_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>

	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        list:[],
        typeList:[],
        type:''
      }
    },
	created(){
    this.getList();
	},
    methods: {
      getToDetail(item){
        this.$router.push({path:'/ConversationDetail',query: {id:item.id}});
      },
      getList(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/simple_jp/list',null,r =>{
          that.$parent.returnCode(r,function(){
            that.list = r.data
            that.$parent.loadModal(false);
          })
        })
      },
      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      },
      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      }
	}
}
</script>
<style scoped>
.sure_btn{
  display: block;
  width: 70%;           /* 按钮宽度，手机上也合适 */
  max-width: 600px;     /* 最大宽度 */
  margin: 20px auto 0;  /* 居中并有间距 */
  padding: 12px 0;      /* 内边距控制高度 */
  font-size: 18px;      /* 字体大小适中 */
  line-height: normal;  /* 去掉原来的103px */
  background: url('../../static/images/level_button.png') no-repeat center;
  background-size: contain;  /* 图片自适应容器 */
  text-align: center;
  color: #fff;
  text-shadow: 2px 2px 0 #001d8c;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.img-box {
  position: relative;
  display: inline-block;
}
.img-box img {
  display: block;
  width: 100%;
  border-radius: 8px;
}
.status-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 8px 20px;
  font-size: 25px;
  color: #fff;

  border-radius: 12px;
}
/* 不同状态颜色 */
.status-1 {
  background: #fd5959;
}
.status-2 {
  background: #fd9901;
}
.status-3 {
  background: #00f474;
}
</style>



// WEBPACK FOOTER //
// src/page/Conversation.vue